import { animated, useSpring } from '@react-spring/web';
import { MyCheckbox } from "components";
import InfoTooltip from "components/InfoTooltip";
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { DropdownOptionFormContainer, DropdownOptionFormFields, DropdownOptionFormFieldsTitle } from "./Theme";

const DropdownOptionForm = ({ dropdownData, disabled, onChange, onDropdownHiddenChange }) => {

  const contentSpring = useSpring({
    opacity: !dropdownData?.hidden ? 1 : 0,
    config: { mass: 1, tension: 200, friction: 24 },
  })

  return (
    <DropdownOptionFormContainer>
      <Row
        className={`d-flex flex-column ${disabled ? "disabled-dropdown-options" : ""}`}
        style={{
          gap: 10,
        }}

      >
        <Col className="col-sm-12" style={{ display: 'flex', alignItems: 'center' }}>
          <MyCheckbox
            name={"hide-dropdown-options"}
            title={"Hide this field"}
            handlechange={(e) => {
              const { checked } = e.target
              onDropdownHiddenChange(checked)
            }}
            checked={dropdownData?.hidden}
          />
          <InfoTooltip text="Hides this entire dropdown field everywhere it's used, instead of just disabling individual options below." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </Col>
      </Row>
      <animated.div
        // when the field is hidden the options are only faded out, so they must not react to the mouse
        aria-hidden={dropdownData?.hidden ? true : undefined}
        style={{
          overflow: 'hidden',
          pointerEvents: dropdownData?.hidden ? 'none' : undefined,
          ...contentSpring
        }}
      >
        <DropdownOptionFormFields>
          <DropdownOptionFormFieldsTitle style={{ display: 'flex', alignItems: 'center' }}>
            Options
            {/* the hint icon forces pointer-events back on, so drop it while hidden */}
            {!dropdownData?.hidden && (
              <InfoTooltip text="Enable or disable individual choices within this dropdown. At least one option must stay checked." style={{ marginLeft: '6px' }} />
            )}
          </DropdownOptionFormFieldsTitle>
          <Row
            className={`d-flex flex-column pl-5 ${disabled ? "disabled-dropdown-options" : ""}`}
            style={{
              gap: 10,
            }}

          >
            {dropdownData?.options?.map((item) => (
              <Col className="col-sm-12" key={item?.value}>
                <MyCheckbox
                  name={item?.value}
                  title={item?.label}
                  handlechange={() => {
                    onChange(item)
                  }}
                  checked={item?.checked}
                />
              </Col>
            ))}
          </Row>
        </DropdownOptionFormFields>
      </animated.div>
    </DropdownOptionFormContainer>
  )
}

export default DropdownOptionForm